<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer009">
<p class="ORIM-Dedication--Front-Matter-"> </p>
<p class="ORIM-Dedication--Front-Matter-" id="_idParaDest-2">For Christina</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// KnifeRiver_5P1.vue?37a96b0a